import { convertCamelCaseToSentence } from "src/utils/CommonUtils";
import { BreadCrumbItem, BreadCrumbUpdateQuery } from "./pageHeader.interface";

// give query whenever you want to replace any item in the breadCrumb
export function getBreadCrumbItems(
  location,
  breadCrumbUpdateQuery?: BreadCrumbUpdateQuery
) {
  const breadCrumbItems: BreadCrumbItem[] = [{ link: "/", pageName: "Home" }];
  const paths = location.pathname.split("/");
  let accumulatePath = "/#";

  paths.forEach((path) => {
    if (path && path != "#") {
      accumulatePath += "/" + path;
      let newBreadCrumbItem = {
        pageName: convertCamelCaseToSentence(path),
        link: accumulatePath,
      };
      breadCrumbItems.push(newBreadCrumbItem);
    }
  });
  if (breadCrumbUpdateQuery) {
    const { updateIndex, updatedName, updatedUrl } = breadCrumbUpdateQuery;
    breadCrumbItems[updateIndex] = {
      pageName: updatedName,
      link: updatedUrl,
    };
  }
  return breadCrumbItems;
}
